export const SETTINGS_TOOLTIP_TYPES = {
  MOVE_MODAL: 'showMoveModal',
  MOVE_DOWN: 'moveDown',
  MOVE_UP: 'moveUp',
  DELETE: 'delete',
  COPY: 'copy',
  RESTORE: 'restore',
};
